<template>
  <div>
    <div id="map">
      <MglMarker v-for="locationMarker in locationMarkers" :key="locationMarker.name"
                 :coordinates="[locationMarker.lng, locationMarker.lat]">
        <div slot="marker" class="marker-ht"></div>
      </MglMarker>
      <MglMarker v-for="companyMarker in companyMarkers" :key="companyMarker.id"
                 :coordinates="companyMarker.latLng"
                 :offset="companyMarker.offset">
        <template slot="marker">
          <ht-company-marker :company="companyMarker.company" :color="companyMarker.color"></ht-company-marker>
        </template>
      </MglMarker>
      <MglMarker v-for="orderMarker in orderMarkers" :key="orderMarker.id" :coordinates="orderMarker.latLng">
        <template slot="marker">
          <ht-order-marker :color="orderMarker.color" :uuid="orderMarker.order.uuid"></ht-order-marker>
        </template>
      </MglMarker>
      <MglMarker v-for="(delivererMarker, index) in delivererMarkers" :key="index"
                 :coordinates="delivererMarker.latLng">
        <template slot="marker">
          <ht-deliverer-marker :color="delivererMarker.color" :deliverer="delivererMarker.deliverer">
          </ht-deliverer-marker>
        </template>
      </MglMarker>

      <vx-card class="orders-card">
        <ul class="flex justify-around options">
          <li @click="ordersTab = 'not-assigned'">
            <a class="inline-block border rounded py-2 px-4 bg-blue-500 hover:bg-blue-700 text-center"
               href="#">
              <span style="font-weight: bold; font-size: 34px">{{
                  notAssignedOrders.length
                }}</span>
              <small style="display: block">Niet Toegewezen</small>
            </a>
          </li>
          <li @click="ordersTab = 'assigned'">
            <a class="inline-block border rounded py-2 px-4 bg-blue-500 hover:bg-blue-700 text-center"
               href="#">
              <span style="font-weight: bold; font-size: 34px">{{
                  assignedOrders.length
                }}</span>
              <small style="display: block">Toegewezen</small>
            </a>
          </li>
          <li @click="ordersTab = 'completed'">
            <a class="inline-block border rounded py-2 px-4 bg-blue-500 hover:bg-blue-700 text-center"
               href="#">
              <span style="font-weight: bold; font-size: 34px">{{
                  completedOrders.length
                }}</span>
              <small style="display: block">Voldaan</small>
            </a>
          </li>
        </ul>
        <vs-list v-if="ordersTab === 'not-assigned'">
          <vs-list-item v-for="order in notAssignedOrders" :key="order.id">
            <div slot="title" style="display: block" @click="openModal(order)">
              <b v-if="order.note === 'LET OP! Dit is een nalevering!'">NALEVERING #{{ order.id }}</b>
              <b v-if="order.note !== 'LET OP! Dit is een nalevering!'">#{{ order.id }}</b>
              <span style="float: right; font-weight: 400">{{
                  order.delivery_time == "Zo snel mogelijk"
                      ? "ZSM"
                      : order.delivery_time
                }}</span>
            </div>
            <div slot="subtitle" @click="openModal(order)">
              <p>{{ order.company.name }}</p>
              <p>Status: {{ getStatus(order) }}</p>
              <p>
                <b>Besteltijd: {{ order.ordered_at }}</b>
              </p>
            </div>
          </vs-list-item>
        </vs-list>
        <vs-list v-if="ordersTab == 'assigned'">
          <vs-list-item v-for="order in assignedOrders" :key="order.id">
            <div slot="title" style="display: block" @click="openModal(order)">
              <b>#{{ order.id }}</b>
              <span style="float: right; font-weight: 400">{{
                  order.delivery_time == "Zo snel mogelijk"
                      ? "ZSM"
                      : order.delivery_time
                }}</span>
            </div>
            <div slot="subtitle" @click="openModal(order)">
              <p>{{ order.company.name }}</p>
              <p>Bezorger: {{
                  order.job.deliverer.insertion != null ? order.job.deliverer.firstname + ' '
                      + order.job.deliverer.insertion + ' ' + order.job.deliverer.lastname :
                      order.job.deliverer.firstname + ' ' + order.job.deliverer.lastname
                }}</p>
              <p>Status: {{ getStatus(order) }}</p>
              <p>
                <b>Besteltijd: {{ order.ordered_at }}</b>
              </p>
            </div>
          </vs-list-item>
        </vs-list>
        <vs-list v-if="ordersTab == 'completed'">
          <vs-list-item v-for="order in completedOrders" :key="order.id">
            <div slot="title" style="display: block" @click="openModal(order)">
              <b>#{{ order.id }}</b>
              <span style="float: right; font-weight: 400">{{
                  order.delivery_time == "Zo snel mogelijk"
                      ? "ZSM"
                      : order.delivery_time
                }}</span>
            </div>
            <div slot="subtitle" @click="openModal(order)">
              <p>{{ order.company.name }}</p>
              <p>Bezorger: {{
                  order.job.deliverer.insertion != null ? order.job.deliverer.firstname + ' '
                      + order.job.deliverer.insertion + ' ' + order.job.deliverer.lastname :
                      order.job.deliverer.firstname + ' ' + order.job.deliverer.lastname
                }}</p>
              <p>Status: {{ getStatus(order) }}</p>
              <p>
                <b>Besteltijd: {{ order.ordered_at }}</b>
              </p>
            </div>
          </vs-list-item>
        </vs-list>
      </vx-card>

      <vx-card class="deliverers-card">
        <ul class="flex justify-around options">
          <li class="mr-3" @click="showActiveDelivers()">
            <a class="inline-block border rounded py-2 px-4 bg-blue-500 hover:bg-blue-700 text-center"
               href="#">
              <span style="font-weight: bold; font-size: 34px">{{
                  activeDeliverers.length
                }}</span>
              <small style="display: block">Actief</small>
            </a>
          </li>
          <li class="mr-3" @click="showInactiveDelivers()">
            <a class="inline-block border rounded py-2 px-4 bg-blue-500 hover:bg-blue-700 text-center"
               href="#">
              <span style="font-weight: bold; font-size: 34px">{{
                  inactiveDeliverers.length
                }}</span>
              <small style="display: block">Inactief</small>
            </a>
          </li>
          <li class="mr-3" @click="showOfficeEmployees()">
            <a class="inline-block border rounded py-2 px-4 bg-blue-500 hover:bg-blue-700 text-center"
               href="#">
              <span style="font-weight: bold; font-size: 34px">{{
                  officeEmployees.length
                }}</span>
              <small style="display: block">Kantoor</small>
            </a>
          </li>
        </ul>
        <ht-deliverer-list :deliverers="activeDeliverers" :show="showActiveDeliverers"></ht-deliverer-list>
        <ht-deliverer-list :deliverers="inactiveDeliverers" :show="showInactiveDeliverers"></ht-deliverer-list>
        <ht-deliverer-list :deliverers="officeEmployees" :show="showOffice"></ht-deliverer-list>
      </vx-card>
    </div>
    <ht-deliverer-popup :deliverer="selectedDeliverer" :active="delivererPopupActive"></ht-deliverer-popup>

    <vs-popup class="order-modal" :title="activeOrderTitle" :active.sync="popupActive" v-if="activeOrder !== null">
      <vs-tabs alignment="fixed">
        <vs-tab label="Details">
          <div class="flex mb-4">
            <div class="w-1/2 bg-grid-color pr-4">
              <div>
                Status:
                <span style="float: right">{{ getStatus(activeOrder) }}</span>
              </div>
              <div>
                Tijd:
                <span style="float: right">{{
                    activeOrder.delivery_time
                  }}</span>
              </div>
              <div>
                Door:
                <span style="float: right">{{ activeOrder.platform }}</span>
              </div>
            </div>
            <div class="w-1/2 bg-grid-color pl-4">
              <v-select v-model="deliverer" :options="allActiveDeliverers" :value="deliverer"
                        label="fullname"
                        v-if="activeOrder.job == null || editDeliverer"/>
              <div v-if="activeOrder.job !== null && !editDeliverer">
                Bezorger:
                <span class="float-right">
                  {{
                    activeOrder.job !== null ? activeOrder.job.deliverer.insertion !== null ? activeOrder.job.deliverer.firstname + " " + activeOrder.job.deliverer.insertion + " " + activeOrder.job.deliverer.lastname : activeOrder.job.deliverer.firstname + " " + activeOrder.job.deliverer.lastname : ""
                  }}
                  <vs-icon @click="
                      editDeliverer
                        ? (editDeliverer = false)
                        : (editDeliverer = true)
                    ">edit
                  </vs-icon>
                </span>
              </div>
              <div v-if="activeOrder.job !== null && !editDeliverer">
                Telefoonnummer:
                <span class="float-right">{{
                    activeOrder.job.deliverer.phone_number
                  }}</span>
              </div>
            </div>
          </div>
          <vs-divider></vs-divider>
          <div class="flex mb-4">
            <div class="w-full bg-grid-color">
              <vs-list>
                <vs-list-item>
                  <template slot="title">Bedrijf:</template>
                  {{ activeOrder.company.name }}
                </vs-list-item>
                <vs-list-item>
                  <template slot="title">Telefoonnummer:</template>
                  {{ activeOrder.company.internal_phone_number }}
                </vs-list-item>
                <vs-list-item>
                  <template slot="title">Adres:</template>
                  {{
                    activeOrder.address.streetname +
                    " " +
                    activeOrder.address.housenumber +
                    ", " +
                    activeOrder.address.postal_code +
                    " " +
                    activeOrder.address.city
                  }}
                  <vs-icon @click="
                      editAddress ? (editAddress = false) : (editAddress = true)
                    ">edit
                  </vs-icon>
                  <div v-if="editAddress">
                    <vs-input placeholder="Straatnaam" v-model="streetname" class="inline-block"
                              size="small"/>
                    <vs-input placeholder="Huisnummer" v-model="housenumber" class="inline-block"
                              size="small"/>
                    <vs-input placeholder="Postcode" v-model="postal_code" class="inline-block"
                              size="small"/>
                    <vs-input placeholder="Stad" v-model="city" class="inline-block" size="small"/>
                  </div>
                </vs-list-item>
                <vs-list-item>
                  <template slot="title">Klant:</template>
                  {{
                    activeOrder.customer.insertion !== null
                        ? activeOrder.customer.firstname +
                        " " +
                        activeOrder.customer.insertion +
                        " " +
                        activeOrder.customer.lastname
                        : activeOrder.customer.firstname +
                        " " +
                        activeOrder.customer.lastname
                  }}
                </vs-list-item>
                <vs-list-item v-if="activeOrder.customer.company_name !== null">
                  <template slot="title">Bedrijf:</template>
                  {{ activeOrder.customer.company_name }}
                </vs-list-item>
                <vs-list-item>
                  <template slot="title">Telefoonnummer:</template>
                  {{ activeOrder.customer.phone_number }}
                </vs-list-item>
                <vs-list-item>
                  <template slot="title">Opmerking:</template>
                  {{ activeOrder.note }}
                </vs-list-item>
                <vs-list-item>
                  <template slot="title">Betaalstatus:</template>
                  {{ activeOrder.payment_status }}
                </vs-list-item>
                <vs-list-item>
                  <template slot="title">Totaal({{ activeOrder.payment_method }}):
                  </template>
                  €
                  {{
                    (activeOrder.price - activeOrder.transaction_fee).toFixed(2)
                  }}
                </vs-list-item>
              </vs-list>
            </div>
          </div>
        </vs-tab>
        <vs-tab label="Bestelling">
          <div>
            <vs-list>
              <vs-list-item v-for="detail in activeOrder.details" :key="detail.id">
                <template slot="title">
                  <p>
                    <b>{{ detail.quantity }}x</b>
                    {{ detail.product.name }}
                  </p>
                </template>
                <template slot="subtitle">
                  <ul class="pl-4">
                    <li v-for="addon in detail.addons" :key="addon.id">
                      {{ addon.name }}
                      <em v-if="addon.price">+€ {{ addon.price }}</em>
                      <strong><em v-if="addon.note">{{ addon.note }}</em></strong>
                    </li>
                  </ul>
                </template>
                € {{ detail.price }}
              </vs-list-item>
            </vs-list>
          </div>
        </vs-tab>
        <vs-tab label="Geschiedenis">
          <div>
            <vs-list>
              <vs-list-item>
                <template slot="title">
                  Besteld:
                </template>
                {{ activeOrder.ordered_at_date }} {{ activeOrder.ordered_at }}
              </vs-list-item>
              <vs-list-item v-if="activeOrder.job !== null && activeOrder.job.assigned_at !== null">
                <template slot="title">
                  Toegewezen:
                </template>
                {{ activeOrder.job.assigned_at }}
              </vs-list-item>
              <vs-list-item
                  v-if="activeOrder.job !== null && activeOrder.job.arrived_at_company !== null">
                <template slot="title">
                  Bij bedrijf:
                </template>
                {{ activeOrder.job.arrived_at_company }}
              </vs-list-item>
              <vs-list-item v-if="activeOrder.job !== null && activeOrder.job.picked_up_at !== null">
                <template slot="title">
                  Opgehaald:
                </template>
                {{ activeOrder.job.picked_up_at }}
              </vs-list-item>
              <vs-list-item v-if="activeOrder.job !== null && activeOrder.job.completed_at !== null">
                <template slot="title">
                  Voldaan:
                </template>
                {{ activeOrder.job.completed_at }}
              </vs-list-item>
            </vs-list>
          </div>
        </vs-tab>
        <vs-tab label="Terugstortingen">
          <vs-list>
            <vs-list-item v-if="refunds === null" title="Terugstotingen laden..." subtitle></vs-list-item>
            <div v-if="refunds !== null">
              <vs-list-item v-if="refunds.length === 0" title="Geen terugstotingen gevonden"
                            subtitle></vs-list-item>
            </div>

            <vs-list-item v-for="refund in refunds" :title="getRefundTitle(refund)">
              <template slot="subtitle">
                Ter waarde van €{{ refund.amount }},- {{ translateTime(refund) }} door {{
                  refund.staff.firstname
                }}
              </template>
            </vs-list-item>
          </vs-list>
        </vs-tab>
        <vs-tab label="Extra opties" class="compensation">
          <hr>
          <vs-list class="flex flex-row extra-options">
            <vs-button class="extraOptionCustom" type="flat" @click="openReprintPopup">
              <img class="imageAdjustments" src="../Orders/popupIcons/bill.png" alt="Reprint">
              <span class="block">Opnieuw afdrukken</span>
            </vs-button>
            <vs-button class="extraOptionCustom" type="flat" @click="openAfterDeliveryPopup">
              <img class="imageAdjustments" src="../Orders/popupIcons/food-delivery.png"
                   alt="Delivery man">
              <span class="block">Nalevering</span>
            </vs-button>
            <vs-button class="extraOptionCustom" type="flat" @click="openPartialReturnPopup">
              <img class="imageAdjustments" src="../Orders/popupIcons/cash.png" alt="Partial return">
              <span class="block">Gedeeltelijk terugstorten</span>
            </vs-button>
            <!--                        <vs-list-item>-->

          </vs-list>
          <hr>
          <vs-list class="flex flex-row extra-options">
            <vs-button class="extraOptionCustom" type="flat" @click="openCompensateRestaurantPopup">
              <img class="imageAdjustments" src="../Orders/popupIcons/credit-card.png"
                   alt="Compensate restaurant">
              <span class="block">Restaurant compenseren</span>
            </vs-button>
            <vs-button class="extraOptionCustom" type="flat" @click="openCompensateCustomerPopup">
              <img class="imageAdjustments" src="../Orders/popupIcons/food.png" alt="Compensate customer">
              <span class="block">Klant compenseren</span>
            </vs-button>

            <vs-button class="extraOptionCustom" type="flat" @click="openCancelOrderPopup">
              <img class="imageAdjustments" src="../Orders/popupIcons/delivery-man.png"
                   alt="Delivery man">
              <span class="block">Annuleren</span>
            </vs-button>
          </vs-list>
        </vs-tab>
      </vs-tabs>
      <vs-button class="float-right vs-con-loading__container" id="save-order-button" color="primary"
                 type="filled"
                 ref="loadableButton" @click="saveModal" :disabled="savingLoading">Opslaan
      </vs-button>
    </vs-popup>
    <ht-quick-company-edit :orders="orders"></ht-quick-company-edit>
    <ht-after-popup></ht-after-popup>
    <ht-partial-popup></ht-partial-popup>
    <ht-compensate-popup></ht-compensate-popup>
    <ht-ccompensate-popup></ht-ccompensate-popup>
    <ht-cancel-popup></ht-cancel-popup>
    <ht-reprint-popup></ht-reprint-popup>
  </div>

</template>

<script>
import PartialReturnPopup from "../Orders/Popups/PartialReturnPopup";
import AfterDeliveryPopup from "../Orders/Popups/AfterDeliveryPopup";
import CompensateRestaurantPopup from "../Orders/Popups/CompensateRestaurantPopup";
import CompensateCustomerPopup from "../Orders/Popups/CompensateCustomerPopup";
import CancelOrderPopup from "../Orders/Popups/CancelOrderPopup";
import ReprintPopup from "../Orders/Popups/ReprintPopup";
import DeliveryDriverList from "./DeliveryDriverList";
import QuickCompanyEditPopup from "./Components/QuickCompanyEditPopup";
import io from "socket.io-client";

import Mapbox from "mapbox-gl";
import {Howl, Howler} from "howler";
import {
  MglMap,
  MglNavigationControl,
  MglGeolocateControl,
  MglMarker,
} from "vue-mapbox";
import OrderMarker from "./Components/OrderMarker";
import DelivererMarker from "./Components/DelivererMarker";
import CompanyMarker from "./Components/CompanyMarker";
import DelivererPopup from "./Components/DelivererPopup";

export default {

  components: {
    MglMap,
    MglNavigationControl,
    MglGeolocateControl,
    MglMarker,
    "ht-deliverer-list": DeliveryDriverList,
    "ht-order-marker": OrderMarker,
    "ht-deliverer-marker": DelivererMarker,
    "ht-company-marker": CompanyMarker,
    "ht-deliverer-popup": DelivererPopup,
    "ht-partial-popup": PartialReturnPopup,
    "ht-after-popup": AfterDeliveryPopup,
    "ht-compensate-popup": CompensateRestaurantPopup,
    "ht-ccompensate-popup": CompensateCustomerPopup,
    "ht-cancel-popup": CancelOrderPopup,
    "ht-reprint-popup": ReprintPopup,
    "ht-quick-company-edit": QuickCompanyEditPopup
  },
  data() {
    return {
      socket: {},
      map: null,
      refunds: [],
      accessToken: "pk.eyJ1IjoibWFhcnRlbnZ3IiwiYSI6ImNqMnN5enh4YjAwNGYyd25vOTRzeDcwZmIifQ.X9XFeEGSq6lt34thD1VfIw", // your access token. Needed if you using Mapbox maps
      mapStyle: "mapbox://styles/mapbox/streets-v9", // your map style
      center: null,
      companyMarkers: [],
      orderMarkers: [],
      locationMarkers: [],
      orders: [],
      companies: [],
      deliverers: [],
      deliveryDriverMarkers: [],
      showActiveDeliverers: true,
      showInactiveDeliverers: false,
      showOffice: false,
      ordersTab: "not-assigned",
      popupActive: false,
      hatchRequests: [],
      savingLoadingDeliverer: false,
      companyPopupActive: false,
      activeOrder: null,
      deliverer: null,
      editDeliverer: false,
      pling: new Howl({
        src: ["/assets/audio/plucky.mp3", "/assets/audio/plucky.ogg"],
      }),
      savingLoading: false,
      streetname: null,
      housenumber: null,
      postal_code: null,
      city: null,
      editAddress: false,
      selectedCompany: null,
      selectedDeliverer: null,
      delivererPopupActive: null,
      confirmDelivererPopupActive: null,
    };
  },
  provide() {
    const self = this;
    return {
      get mapbox() {
        return self.mapbox;
      },
      get map() {
        return self.map;
      },
      get actions() {
        return self.actions;
      },
    };
  },
  created() {
    this.socket = io("https://ws-2.hebtrek.nl:42069", {
      secure: true, auth: {
        token: "nN04eHbQ0n7D8NYPHhdZ"
      }
    });
    this.$store.commit("TOGGLE_REDUCE_BUTTON", true);
    // We need to set mapbox-gl library here in order to use it in template
    this.mapbox = Mapbox;
    this.mapbox.accessToken = this.accessToken;
    this.center = JSON.parse(localStorage.getItem("staff-area-selected"));
  },
  mounted() {

    this.map = new Mapbox.Map({
      container: "map",
      style: this.mapStyle,
      center: [this.center.lng, this.center.lat],
      zoom: this.center.zoom,
    });

    this.resizeMap();

    this.locationMarkers = [
      {
        name: "Spijkenisse",
        lng: 4.302286,
        lat: 51.851773,
      },
      {
        name: "Schiedam",
        lng: 4.425552,
        lat: 51.923742,
      },
      {
        name: "Ijsselmonde",
        lng: 4.540668,
        lat: 51.871228,
      },
      {
        name: "Delft",
        lng: 4.340991,
        lat: 52.019975,
      },
    ];


    // Fetch companies
    this.getCompanies().then(() => {
      this.updateCompanyMarkers();
    });
    this.getOrders().then(() => {
      this.orders.map((order) => {
        if (order.job !== null) {
          if (order.job.completed_at !== null) {
            return;
          }
          this.orderMarkers.push({
            id: order.uuid,
            color: "#50b830",
            latLng: [order.address.lng, order.address.lat],
            order: order,
          });
        } else {
          this.orderMarkers.push({
            id: order.uuid,
            color: "#b35a4e",
            latLng: [order.address.lng, order.address.lat],
            order: order,
          });
        }
      });
    });

    this.getDeliverers().then(() => {
      this.deliverer = this.activeDeliverers[0];
    });

    this.$events.listen("open-order-modal", (event) => {
      this.openModalFromEvent(event);
    });

    this.$events.listen("company-update", (company) => {
      this.updateCompanyMarkers();
    });

    this.$events.listen("open-company-modal", (event) => {
      this.openCompanyModalFromEvent(event);
    });

    this.$events.listen("open-deliverer-modal", (event) => {
    });

    this.$events.listen("staff-area-selected", (event) => {
      if (this.center === event) {
        console.log("prevented");
        return;
      }
      this.center = event;
    });

    //Subscribe Socket.io to location_changed channel
    this.socket.on("deliverer_location", (data) => {
      let uDeliverer = JSON.parse(data);
      this.deliverers.map((deliverer) => {
        if (deliverer._id === uDeliverer._id) {
          deliverer.phone = uDeliverer.phone;
        }
      });
    });

    // Drivers clocking in.
    this.socket.on("driver_in", (reg) => {
      let registration = JSON.parse(reg);
      this.deliverers.map((deliverer) => {
        if (deliverer._id === registration.deliverer_id) {
          deliverer.active = true;
        }
      });
    });

    // Drivers clocking out.
    this.socket.on("driver_out", (reg) => {
      let registration = JSON.parse(reg);
      this.deliverers.map((deliverer) => {
        if (deliverer._id === registration.deliverer_id) {
          deliverer.active = false;
        }
      });
    });

    // Update company status on map and quick edit
    this.socket.on("company_update", (c) => {
      let company = JSON.parse(c);
      this.updateCompanyList(company);
    });

    this.socket.on("hatch_decision", (data) => {
      this.$events.fire('staff-hatch-decision', data);
    });


    this.$pusher
        .subscribe("private-deliverers")
        .bind("App\\Events\\DelivererLocationChanged", (event) => {
          this.deliverers.map((deliverer) => {
            if (deliverer.id === event.deliverer.id) {
              deliverer.speed = event.location.coords.speed;
              deliverer.chargingPhone = event.location.battery.is_charging;
              deliverer.batteryLife = event.location.battery.level;
              deliverer.location = event.location;
            }
          });
        })
        .bind("App\\Events\\StaffBatteryRequestDecision", (data) => {
          this.$events.fire('staff-battery-decision', JSON.parse(data.deliverer));
        })
        .bind("App\\Events\\RequestOpenHatch", (data) => {
          this.$events.fire('open-hatch-request', JSON.parse(data.deliverer));
        })
        .bind("App\\Events\\RequestBatteryChange", (data) => {
          this.$events.fire('battery-change-request', JSON.parse(data.deliverer));

        });
    this.$pusher
        .subscribe("private-jobs")
        .bind("App\\Events\\NewBackofficeOrder", (data) => {
          this.$http
              .get(
                  "https://staffapi.hebtrek.nl/v1/delivery/orders/" + data.orderUUID,
                  {
                    headers: {
                      Authorization:
                          "Bearer " + JSON.parse(localStorage.getItem("stafftoken")),
                    },
                  }
              )
              .then((response) => {
                this.orders.unshift(response.data.data);
                console.log(response.data.data);
                let order = response.data.data;
                this.orderMarkers.push({
                  id: order.uuid,
                  color: "#b35a4e",
                  latLng: [order.address.lng, order.address.lat],
                  order: order,
                });

                this.pling.play();
                if (order.company.area !== this.center.name) {
                  this.$vs.notify({
                    title: 'Nieuwe Bestelling!',
                    text: 'Er is een nieuwe bestelling in ' + order.company.area,
                    position: 'top-center',
                    color: 'green'
                  });
                }
              })
              .catch((error) => {
                console.log(error);
                this.$util.logError(error, this.$vs);
              });
        })
        .bind("App\\Events\\OrderAddressEdited", (data) => {
          this.$http
              .get(
                  "https://staffapi.hebtrek.nl/v1/delivery/orders/" + data.orderUUID,
                  {
                    headers: {
                      Authorization:
                          "Bearer " + JSON.parse(localStorage.getItem("stafftoken")),
                    },
                  }
              )
              .then((response) => {
                this.orders.map((order) => {
                  if (order.uuid == data.orderUUID) {
                    order = response.data.data;
                    this.activeOrder = order;
                  }
                });
              })
              .catch((error) => {
                this.$util.logError(error, this.$vs);
              });
        })
        .bind("App\\Events\\CompanyDeliveryTimeEdited", (data) => {
          this.companies.map((company) => {
            if (company.slug == data.companySLUG) {
              company.delivery_time = data.companyDELIVERYTIME;
              this.selectedCompany.delivery_time = data.companyDELIVERYTIME;
            }
          });
        })
        .bind("App\\Events\\jobAssignedToDeliverer", (data) => {
          this.$http
              .get(
                  "https://staffapi.hebtrek.nl/v1/delivery/orders/" +
                  data.job.orderUUID,
                  {
                    headers: {
                      Authorization:
                          "Bearer " + JSON.parse(localStorage.getItem("stafftoken")),
                    },
                  }
              )
              .then((response) => {
                this.orders.map((order) => {
                  if (order.uuid == response.data.data.uuid) {
                    order.job = response.data.data.job;
                  }
                });
                this.orderMarkers.map((orderMarker) => {
                  if (orderMarker.order.uuid == response.data.data.uuid) {
                    orderMarker.color = "#50b830";
                  }
                });
                this.$http.get("https://staffapi.staging.hebtrek.nl/v1/deliverer/job?orderId=" + response.data.data.id,
                    {
                      headers: {
                        Authorization:
                            "Bearer " + JSON.parse(localStorage.getItem("stafftoken")),
                      },
                    }
                ).then((response) => {
                  this.deliverers.map((deliverer) => {
                    if (deliverer._id === response.data.job.deliverer._id)
                      deliverer.jobs++;
                  });
                });
              })
              .catch((error) => {
                this.$util.logError(error, this.$vs);
              });
        })
        .bind("App\\Events\\jobArrived", (data) => {
          this.$http
              .get(
                  "https://staffapi.hebtrek.nl/v1/delivery/orders/" +
                  data.job.orderUUID,
                  {
                    headers: {
                      Authorization:
                          "Bearer " + JSON.parse(localStorage.getItem("stafftoken")),
                    },
                  }
              )
              .then((response) => {
                this.orders.map((order) => {
                  if (order.uuid === response.data.data.uuid) {
                    order.job = response.data.data.job;
                    deliverer.orderData.push(response.data.data.job);
                  }
                });
                this.deliverers.map((deliverer) => {
                  if (deliverer.id === response.data.data.job.deliverer._id) {
                    deliverer.orderData.push(response.data.data.job);
                  }
                });
              })
              .catch((error) => {
                this.$util.logError(error, this.$vs);
              });
        })
        .bind("App\\Events\\jobPickedUp", (data) => {
          this.$http
              .get(
                  "https://staffapi.hebtrek.nl/v1/delivery/orders/" +
                  data.job.orderUUID,
                  {
                    headers: {
                      Authorization:
                          "Bearer " + JSON.parse(localStorage.getItem("stafftoken")),
                    },
                  }
              )
              .then((response) => {
                this.orders.map((order) => {
                  if (order.uuid === response.data.data.uuid) {
                    order.job = response.data.data.job;
                  }
                });
              })
              .catch((error) => {
                this.$util.logError(error, this.$vs);
              });
        })
        .bind("App\\Events\\jobCompleted", (data) => {
          this.$http
              .get(
                  "https://staffapi.hebtrek.nl/v1/delivery/orders/" +
                  data.job.orderUUID,
                  {
                    headers: {
                      Authorization:
                          "Bearer " + JSON.parse(localStorage.getItem("stafftoken")),
                    },
                  }
              )
              .then((response) => {
                this.orders.map((order) => {
                  if (order.uuid === response.data.data.uuid) {
                    order.job = response.data.data.job;
                  }
                });
                this.orderMarkers.map((marker, i) => {
                  if (marker.order.uuid === response.data.data.uuid) {
                    this.orderMarkers.splice(i, 1);
                  }
                });
                this.deliverers.map((deliverer) => {
                  if (deliverer._id === response.data.data.job.deliverer._id) {
                    deliverer.jobs--;
                    if (deliverer.jobs === 0) {
                      this.$util.notify(
                          "Bezorger vrij",
                          deliverer.firstname +
                          " in " +
                          deliverer.area +
                          " heeft geen orders meer!",
                          this.$vs
                      );
                    }
                    deliverer.orderData.map((order, i) => {
                      if (order.uuid === response.data.data.uuid) {
                        deliverer.orderData.splice(i, 1);
                      }
                    });
                  }
                });
              })
              .catch((error) => {
                this.$util.logError(error, this.$vs);
              });
        });
  },
  computed: {
    officeEmployees: function () {
      return this.deliverers.filter((deliverer) => {
        // Back office employees
        if (deliverer.office === true) {
          return deliverer.active;
        }
      });
    },
    allActiveDeliverers: function () {
      return this.deliverers.filter((deliverer) => {
        if (deliverer.area == this.center.name) {
          return deliverer.active;
        }
      });
    },
    activeDeliverers: function () {
      return this.deliverers.filter((deliverer) => {
        // Back office employees
        if (deliverer.area == this.center.name && deliverer.office === false) {
          return deliverer.active;
        }
      });
    },
    inactiveDeliverers: function () {
      return this.deliverers.filter((deliverer) => {
        if (deliverer.area == this.center.name) {
          return !deliverer.active;
        }
      });
    },
    notAssignedOrders: function () {
      return this.orders.filter((order) => {
        if (order.company.area === this.center.name) {
          return order.job == null;
        }
      });
    },
    assignedOrders: function () {
      return this.orders.filter((order) => {
        if (order.job !== null) {
          if (order.company.area === this.center.name) {
            return order.job.status === "ASSIGNED" || order.job.status === "RECEIVED" || order.job.status === "WAITING_AT_COMPANY";
          }
        }
      });
    },
    completedOrders: function () {
      return this.orders.filter((order) => {
        if (order.job !== null) {
          if (order.company.area === this.center.name) {
            return order.job.status === "DELIVERED";
          }
        }
      });
    },
    activeOrderTitle: function () {
      if (this.activeOrder !== null) {
        return "Bestelnummer #" + this.activeOrder.id;
      }
    },

    delivererMarkers: function () {
      let delivererMarkers = [];
      this.activeDeliverers.map((deliverer) => {
        let color = deliverer.jobs > 0 ? "orange" : "#00420D";
        if (deliverer.phone !== null) {
          delivererMarkers.push({
            id: deliverer._id,
            color: color,
            latLng: [
              deliverer.phone.long,
              deliverer.phone.lat,
            ],
            deliverer: deliverer,
          });
        }
      });
      return delivererMarkers;
    },
  },
  watch: {
    activeOrder: function () {
      this.streetname = this.activeOrder.address.streetname;
      this.housenumber = this.activeOrder.address.housenumber;
      this.postal_code = this.activeOrder.address.postal_code;
      this.city = this.activeOrder.address.city;
    },
    selectedCompany: function () {
      this.deliveryTime = this.selectedCompany.delivery_time;
    },
    center: function () {
      this.map.setCenter([this.center.lng, this.center.lat]);
      this.map.setZoom(this.center.zoom);
    },
  },
  methods: {
    updateCompanyList(updatedCompany) {
      for (let i = 0; i < this.companies.length; i++) {
        if (this.companies[i].id === updatedCompany.id) {
          this.companies[i] = updatedCompany;
          this.updateCompanyMarkers();
          this.$events.fire("quick-edit-update", updatedCompany);
          break;
        }
      }
    },

    updateCompanyMarkers() {
      this.companyMarkers = [];
      this.companies.map((company) => {
        this.companyMarkers.push({
          id: company.id,
          offset: [-10, -20],
          latLng: [company.lng, company.lat],
          company: company,
          color: company.status === 2 ? "#e85656" : "#00420D"
        });
      });
    },

    isOffice: function (value) {
      return value === 1;
    },

    debug() {
      console.log(this.orders.filter((order) => {
        if (order.company.area === this.center.name) {
          return order.job == null;
        }
      }));
    },

    openPartialReturnPopup() {
      this.$events.fire('open-partial-modal', this.activeOrder);
      this.popupActive = false;
    },
    getRefunds(order) {
      this.$http.get("https://staffapi.hebtrek.nlv1/order/refunds?order_id=" + order.id, {
        headers: {
          Authorization: 'Bearer ' + JSON.parse(localStorage.getItem('stafftoken'))
        },
      }).then((response) => {
        this.refunds = response.data.refunds;
      }).catch((error) => {
        this.$util.logError(error, this.$vs);
      });
    },
    openAfterDeliveryPopup() {
      this.$events.fire('open-after-modal', this.activeOrder);
      this.popupActive = false;
    },
    openCompensateRestaurantPopup() {
      this.$events.fire('open-compensate-modal', this.activeOrder);
      this.popupActive = false;
    },
    openCompensateCustomerPopup() {
      this.$events.fire('open-ccompensate-modal', this.activeOrder);
      this.popupActive = false;
    },
    openCancelOrderPopup() {
      let data = {
        _method: 'POST',
        order_id: this.activeOrder.id
      };
      this.$http
          .post("https://api.staging.hebtrek.nl/staff/order/cancel", data, {
            headers: {
              Authorization:
                  "Bearer " + JSON.parse(localStorage.getItem("stafftoken")),
            },
          })
          .then(() => {
            this.popupActive = false;
            this.$util.notify('Gelukt', 'Order is geannuleerd', this.$vs);
            for (let i = 0; i < this.orders.length; i++) {
              let compare = this.orders[i];
              if (compare.id === this.activeOrder.id) {
                this.orders.splice(i, 1);
                break;
              }
            }
          })
          .catch((error) => {
            this.$util.logError(error, this.$vs);
          });
    },
    openReprintPopup() {
      let data = new FormData();
      data.append("orderId", this.activeOrder.id);
      this.$http
          .post("v1/company/order/reprint", data, {
            headers: {
              Authorization:
                  "Bearer " + JSON.parse(localStorage.getItem("stafftoken")),
            },
          })
          .then(() => {
            this.showPopup = false;
            this.$util.notify('Gelukt', 'Order is opieuw afgedrukt', this.$vs);
          })
          .catch((error) => {
            this.$util.logError(error, this.$vs);
          });
    },

    isActive(id) {
      this.hatchRequests.map((item) => {
        if (item === id) {
          return true;
        }
      });
      return false;
    },
    showOfficeEmployees: function () {
      this.showOffice = true;
      this.showActiveDeliverers = false;
      this.showInactiveDeliverers = false;
    },
    showActiveDelivers: function () {
      this.showOffice = false;
      this.showActiveDeliverers = true;
      this.showInactiveDeliverers = false;
    },
    showInactiveDelivers: function () {
      this.showOffice = false;
      this.showActiveDeliverers = false;
      this.showInactiveDeliverers = true;
    },
    openConfirm(deliverer) {
      this.delivererPopupActive = false;
      this.confirmDelivererPopupActive = true;
    },
    getCompanies: function () {
      return this.$http
          .get("https://staffapi.staging.hebtrek.nl/v1/delivery/companies/list", {
            headers: {
              Authorization:
                  "Bearer " + JSON.parse(localStorage.getItem("stafftoken")),
            },
          })
          .then((response) => {
            this.companies = response.data;
          })
          .catch((error) => {
            this.$util.logError(error, this.$vs);
          });
    },
    getOrders: function () {
      return this.$http
          .get("https://staffapi.hebtrek.nl/v1/delivery/orders/list", {
            headers: {
              Authorization:
                  "Bearer " + JSON.parse(localStorage.getItem("stafftoken")),
            },
          })
          .then((response) => {
            this.orders = response.data.reverse();
          })
          .catch((error) => {
            this.$util.logError(error, this.$vs);
          });
    },
    getDeliverers: function () {
      return this.$http
          .get("https://staffapi.staging.hebtrek.nl/v1/deliverers/list", {
            headers: {
              Authorization:
                  "Bearer " + JSON.parse(localStorage.getItem("stafftoken")),
            },
          })
          .then((response) => {
            this.deliverers = response.data;
          })
          .catch((error) => {
            this.$util.logError(error, this.$vs);
          });
    },
    getStatus: function (order) {
      if (order !== null) {
        var str = "";
        if (order.status == "accepted" || order.status == "sent") {
          if (order.job !== null) {
            if (order.job.arrived_at_company !== null) {
              if (
                  order.job.assigned_at !== null &&
                  order.job.arrived_at_company == null &&
                  order.job.picked_up_at == null &&
                  order.job.completed_at == null
              ) {
                str = "Gekoppeld";
              }
              if (
                  order.job.assigned_at !== null &&
                  order.job.arrived_at_company !== null &&
                  order.job.picked_up_at == null &&
                  order.job.completed_at == null
              ) {
                str = "Bij bedrijf";
              }
              if (
                  order.job.assigned_at !== null &&
                  order.job.arrived_at_company !== null &&
                  order.job.picked_up_at !== null &&
                  order.job.completed_at == null
              ) {
                str = "Opgehaald";
              }
              if (
                  order.job.assigned_at !== null &&
                  order.job.arrived_at_company !== null &&
                  order.job.picked_up_at !== null &&
                  order.job.completed_at !== null
              ) {
                str = "Voldaan";
              }
            } else {
              if (
                  order.job.assigned_at !== null &&
                  order.job.picked_up_at == null &&
                  order.job.completed_at == null
              ) {
                str = "Gekoppeld";
              }
              if (
                  order.job.assigned_at !== null &&
                  order.job.picked_up_at !== null &&
                  order.job.completed_at == null
              ) {
                str = "Opgehaald";
              }
              if (
                  order.job.assigned_at !== null &&
                  order.job.picked_up_at !== null &&
                  order.job.completed_at !== null
              ) {
                str = "Voldaan";
              }
            }
          } else {
            str = order.status;
          }
        } else {
          str = order.status;
        }
        return str;
      }
    },
    openModal: function (order) {
      this.popupActive = true;
      this.activeOrder = order;
    },
    openModalFromEvent: function (uuid) {
      this.orders.map((order) => {
        if (order.uuid == uuid) {
          this.popupActive = true;
          this.activeOrder = order;
        }
      });
    },
    openCompanyModalFromEvent(company) {
      this.$events.fire('open-company-quick-edit', company, this.orders);
    },
    openDelivererModalFromEvent: function (deliverer) {
      console.log(deliverer.fullname);
      this.delivererPopupActive = true;
      this.selectedDeliverer = deliverer;
    },
    saveModal() {
      this.$util.loading("#save-order-button", this.$vs);
      this.savingLoading = true;
      if (this.editDeliverer == true) {
        return this.saveDeliverer();
      }

      if (this.editAddress == true) {
        return this.saveAddress();
      }

      let data = new FormData();
      data.append('order', this.activeOrder.id);
      data.append('deliverer', this.deliverer._id);
      this.$http
          .post(
              "https://staffapi.staging.hebtrek.nl/v1/delivery/jobs/create",
              data,
              {
                headers: {
                  Authorization:
                      "Bearer " + this.$util.getStaffToken(),
                },
              }
          )
          .then(() => {
            this.$vs.loading.close("#save-order-button > .con-vs-loading");

            this.savingLoading = false;
          })
          .catch((error) => {
            this.$util.logError(error, this.$vs);
            this.$vs.loading.close("#save-order-button > .con-vs-loading");
            this.savingLoading = false;
          });
    },
    saveDeliverer() {
      let data = new FormData();
      let oldDeliverer = this.activeOrder.job.deliverer;
      console.log(oldDeliverer);
      data.append('order', this.activeOrder.id);
      data.append('deliverer', this.deliverer._id);
      this.$http
          .post(
              "https://staffapi.staging.hebtrek.nl/v1/delivery/jobs/edit",
              data,
              {
                headers: {
                  Authorization:
                      "Bearer " + this.$util.getStaffToken(),
                },
              }
          )
          .then((response) => {
            this.deliverers.map((deliverer) => {
              if (deliverer._id === oldDeliverer._id) {
                deliverer.jobs--;
              }
            });
            this.editDeliverer = false;
            this.savingLoading = false;
            this.$vs.loading.close("#save-order-button > .con-vs-loading");
          })
          .catch((error) => {
            this.savingLoading = false;
            this.$util.logError(error, this.$vs);
            this.$vs.loading.close("#save-order-button > .con-vs-loading");
          });
    },
    saveAddress: function () {
      this.$http
          .post(
              "https://staffapi.hebtrek.nl/v1/delivery/jobs/edit/address/" +
              this.activeOrder.uuid,
              {
                streetname: this.streetname,
                housenumber: this.housenumber,
                postal_code: this.postal_code,
                city: this.city,
              },
              this.$util.getConfig())
          .then((response) => {
            console.log(response);
            this.editAddress = false;
            this.savingLoading = false;
            this.$vs.loading.close("#save-order-button > .con-vs-loading");
          })
          .catch((error) => {
            this.savingLoading = false;
            this.$util.logError(error, this.$vs);
            this.$vs.loading.close("#save-order-button > .con-vs-loading");
          });
    },
    resizeMap: function (event) {
      this.map.resize();
    },
  },
  beforeDestroy() {
    this.$store.commit("TOGGLE_REDUCE_BUTTON", false);
  },
};
</script>

<style lang="scss">
#map,
.mgl-map-wrapper {
  top: 0;
  height: 100vh;
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
}

.marker-ht {
  background-image: url("../../../assets/images/hebtrek-marker.png");
  width: 23px;
  height: 30px;
}

.marker-company {
  width: 40px;
  height: 40px;
  border: solid 2px #00420d;
  border-radius: 50% 50% 0 50%;
  background-color: white;
  background-position: center;
  background-size: cover;

  h6 {
    margin-left: -10px;
    padding-top: 10px;
  }
}

.orders-card {
  position: absolute;
  top: 100px;
  left: 30px;
  width: 300px;
  overflow: hidden;
  z-index: 9999;

  .options {
    width: 280px;
  }

  .vs-list {
    overflow: scroll;
    max-height: 73vh;

    .list-titles {
      width: 280px;
    }
  }
}

.deliverers-card {
  position: absolute;
  top: 100px;
  right: 30px;
  width: 300px;
  overflow: hidden;
  z-index: 9999;

  .options {
    width: 280px;
  }

  .vs-list {
    overflow: scroll;
    max-height: 73vh;

    .list-titles {
      width: 280px;
    }
  }
}

@media only screen and (max-width: 768px) {
  .vs-popup {
    width: 400px !important;
  }
}

.extra-options {
  display: flex;
  justify-content: space-around;

  .vs-list-item .vs-button {
    display: flex;
    justify-content: space-around;
    padding: 0 !important;
  }

  .block {
    color: #000;
  }

  img {
    height: 5em;
    width: 5em;
  }
}
</style>
